import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import toast from "react-hot-toast";
import * as api from "helper/helper";
import LoadingButton from "../LoadingButton/LoadingButton";

/*const TEST_ERROR  = {
    SUCCESS  : 'Success',
    FAIL     : 'Fail',
    ID_ERROR : 'ID Error'
};
Object.freeze(TEST_ERROR)*/

const TIPO_ACCION = {
  APROBAR: "Aprobar",
  RECHAZAR: "Rechazar",
};
Object.freeze(TIPO_ACCION);

const CreditLevelActionsModal = forwardRef(({ item, reloadCredit }, ref) => {
  const operacion = item?.tipoDeSolicitud ?? {};

  const modalButtonRef = useRef();

  const [isLoading, setIsLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    toggleModal: () => {
      modalButtonRef.current.click();
    },
  }));

  let mensaje = "";
  let mode = "";
  let title = "";
  if (item?.comentarioCreador != null) {
    mensaje = item?.comentarioCreador;
  }
  if (operacion === "LimiteCredito") {
    mode = "Solicitud de Cambio";

    const nivelActual = item.limiteCreditoActual.toLocaleString("en-US");
    const nivelNuevo = item.limiteCreditoSolicitado.toLocaleString("en-US");

    title = ` ¿Desea Aprobar el Cambio de Limite de Credito de $${nivelActual} a $${nivelNuevo}?`;
  } else if (operacion === "Nivel") {
    mode = "Solicitud de Cambio";

    const nivelActual = item.nivelActualNombre;
    const nivelNuevo = item.nivelSolicitadoNombre;

    title = ` ¿Desea Aprobar el Cambio de Nivel de ${nivelActual} a ${nivelNuevo}?`;
  } else if (operacion === "Congelar" || operacion === "Descongelar") {
    //const mode = !item.congelado ? "Congelar" : "Descongelar";

    title = ` ¿Desea Aprobar el Cambio a ${operacion}?`;
    mode = "Solicitud de Cambio";
  } else if (operacion === "OrdenVentaCancelada") {
    title = ` ¿Desea Aprobar la Cancelación de Orden de Venta?`;
    mode = "Solicitud de Cambio";
  } else if (operacion === "OrdenVentaDevolucion") {
    title = ` ¿Desea Aprobar la Devolución de Orden de Venta?`;
    mode = "Solicitud de Cambio";
  }

  async function apply(tipoDeAccion) {
    const operacion = item.tipoDeSolicitud;

    //setIsLoading
    setIsLoading(true);
    const toastId = toast.loading("Solicitando...");

    let response = await api
      .asociadosSolicitudesRevisar(item.id, {
        tipoDeSolicitud: operacion,
        tipoDeAccion,
        fecha: new Date().toJSON(),
      })
      .catch((e) => {
        setIsLoading(false);
        toast.dismiss(toastId);
        if (e.esError && e.codigoError && e.mensaje) {
          toast.error(`Error al Revisar Solicitud. ${e.mensaje}`);
          //  setIsLoading(false);
          return;
        }
        toast.error("Error al Revisar Solicitud.");
        //  setIsLoading(false);
      });

    toast.dismiss(toastId);
    setIsLoading(false);

    if (
      operacion === "OrdenVentaCancelada" &&
      tipoDeAccion === TIPO_ACCION.APROBAR
    ) {
      cancelOrden();
      return;
    } else if (
      operacion === "OrdenVentaDevolucion" &&
      tipoDeAccion === TIPO_ACCION.APROBAR
    ) {
      devolverOrden();
      return;
    }

    if (!response) return;

    //  toast.success("¡Cambio Solicitado...!");
    //    reloadOrdenes();
    modalButtonRef.current.click();
    if (reloadCredit) reloadCredit();
  }

  async function cancelOrden() {
    const ordenVentaId = item.ordenVenta.id;

    //setIsLoading
    setIsLoading(true);

    const toastId = toast.loading("Solicitando...");

    let response = await api.ordenVentaCancela(ordenVentaId).catch((e) => {
      setIsLoading(false);
      toast.dismiss(toastId);
      if (e.esError && e.codigoError && e.mensaje) {
        toast.error(`Error al Cancelar Orden. ${e.mensaje}`);
        //  setIsLoading(false);
        return;
      }
      toast.error("Error al Cancelar Orden.");
      //  setIsLoading(false);
    });

    toast.dismiss(toastId);
    setIsLoading(false);

    if (!response) return;

    toast.success("Orden Cancelada...!");
    //    reloadOrdenes();
    if (reloadCredit) reloadCredit();

    modalButtonRef.current.click();
  }

  async function devolverOrden() {
    const ordenVentaId = item.ordenVenta.id;

    //setIsLoading
    setIsLoading(true);

    const toastId = toast.loading("Solicitando...");

    let response = await api.ordenVentaDevolver(ordenVentaId).catch((e) => {
      setIsLoading(false);
      toast.dismiss(toastId);
      if (e.esError && e.codigoError && e.mensaje) {
        toast.error(`Error al Devolver Orden. ${e.mensaje}`);
        //  setIsLoading(false);
        return;
      }
      toast.error("Error al Devolver Orden.");
      //  setIsLoading(false);
    });

    toast.dismiss(toastId);
    setIsLoading(false);

    if (!response) return;

    toast.success("Orden Devolver...!");
    //    reloadOrdenes();
    if (reloadCredit) reloadCredit();

    modalButtonRef.current.click();
  }

  return (
    <>
      <button
        ref={modalButtonRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropChangeLevelLimit"
        hidden
      >
        Launch static backdrop modal
      </button>

      <div
        className="modal fade"
        id="staticBackdropChangeLevelLimit"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropChangeLevelLimitLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {mode}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <svg xmlns="http://www.w3.org/2000/svg" className="d-none">
              <symbol id="check-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
              </symbol>
              <symbol id="info-fill" viewBox="0 0 16 16">
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
              </symbol>
              <symbol id="exclamation-triangle-fill" viewBox="0 0 16 16">
                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
              </symbol>
            </svg>

            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label htmlFor="recipient-name" className="col-form-label">
                    {title}
                  </label>
                  {/*<input type="text" className="form-control" id="recipient-name" />*/}
                </div>
                <div className="mb-3">
                  <div className="alert alert-warning" role="alert">
                    <svg
                      className="bi flex-shrink-0 me-2"
                      role="img"
                      aria-label="Info:"
                      style={{
                        width: "1em",
                        height: "1em",
                        verticalAlign: "-.125em",
                        fill: "currentcolor",
                      }}
                    >
                      <use href="#info-fill" />
                    </svg>
                    <small>
                      <b>MENSAJE:</b>
                    </small>
                    <br />
                    <br />
                    {mensaje}
                  </div>
                </div>
                <div className="mb-3" hidden>
                  <label htmlFor="message-text" className="col-form-label">
                    Nota:
                  </label>
                  <textarea
                    className="form-control"
                    id="message-text"
                  ></textarea>
                </div>
              </form>
            </div>

            <div className="modal-footer">
              <div className="">
                <LoadingButton
                  style={{ height: "38px" }}
                  onClick={async (e) => {
                    apply(TIPO_ACCION.APROBAR);
                  }}
                  text={"Aprobar"}
                  loadingText={"Actualizando..."}
                  isLoading={isLoading}
                />

                <LoadingButton
                  style={{ height: "38px" }}
                  onClick={async (e) => {
                    apply(TIPO_ACCION.RECHAZAR);
                  }}
                  text={"Rechazar"}
                  loadingText={"Actualizando..."}
                  isLoading={isLoading}
                />
              </div>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default CreditLevelActionsModal;
